import type { IconData } from '@stacksjs/iconify-core'

export const folderF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M10.83 2H17a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3h5c1.306 0 2.417.835 2.83 2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default folderF
